"use client";
import { cn } from "@/lib/utils";

const defaultAvatarUrls = [
  "https://cdn-crayo.com/lp/public/landing/avatars/1.png",
  "https://cdn-crayo.com/lp/public/landing/avatars/2.png",
  "https://cdn-crayo.com/lp/public/landing/avatars/3.png",
  "https://cdn-crayo.com/lp/public/landing/avatars/4.png",
  "https://cdn-crayo.com/lp/public/landing/avatars/5.png",
  "https://cdn-crayo.com/lp/public/landing/avatars/6.png",
];

interface AvatarCirclesProps {
  className?: string;
  numPeople?: number;
  avatarUrls?: string[];
  imgClassName?: string;
}

export const AvatarCircles = ({
  numPeople,
  className,
  avatarUrls = defaultAvatarUrls,
  imgClassName,
}: AvatarCirclesProps) => {
  return (
    <div className={cn("relative ml-4 mt-4 inline-block", className)}>
      <div className="flex flex-wrap">
        {avatarUrls.map((url, index) => (
          <img
            key={index}
            className={cn(
              "-ml-4 -mt-4 h-[70px] w-[70px] shrink-0 rounded-full border-2 border-white object-cover dark:border-gray-800 md:h-[80px] md:w-[80px]",
              imgClassName,
            )}
            src={url}
            width={40}
            height={40}
            alt={`Avatar ${index + 1}`}
            draggable={false}
            style={{
              touchAction: "none",
              userSelect: "none",
              pointerEvents: "none",
            }}
          />
        ))}
        {(numPeople ?? 0) > 0 && (
          <a className="-ml-4 -mt-4 flex h-[70px] w-[70px] items-center justify-center rounded-full border-2 border-white bg-black text-center text-xs font-medium text-white hover:bg-gray-600 dark:border-gray-800 dark:bg-white dark:text-black md:h-[80px] md:w-[80px]">
            +{numPeople}
          </a>
        )}
      </div>
    </div>
  );
};
